import type { ErrorInfo } from 'react'

type CaptureReactException = (
  error: unknown,
  errorInfo: ErrorInfo,
  hint?: {
    mechanism: {
      handled: boolean
      type: string
    }
  },
) => unknown

export function createRouterErrorHandler(captureReactException: CaptureReactException) {
  return (error: Error, errorInfo: ErrorInfo) => {
    captureReactException(error, errorInfo, {
      mechanism: {
        handled: true,
        type: 'auto.function.react.error_boundary.tanstack_router',
      },
    })
  }
}
